import { WithClassName } from "@/types/base";
import { useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { isAuthUser } from "@/utils/status";
import { chakra, Flex } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { AlbumCollector } from "../AlbumCollector";
import Post from "../Post";

const ImageBusinessOpComponent: React.FC<WithClassName> = ({ className }) => {
  const { translate } = useTranslate();
  if (!isAuthUser()) {
    return null;
  }
  return (
    <Flex className={className} justifyContent="space-between" w="100%">
      <Post flex={1} mr="16px" buttonType="outline">
        {translate(Editor_Words.submitToPublic)}
      </Post>
      <AlbumCollector />
    </Flex>
  );
};

export const ImageBusinessOp = chakra(observer(ImageBusinessOpComponent));
